import React from "react";

import { StyledSVG } from "../StyledIcon";

export const StoriesIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M2.25 5C2.25 3.89543 3.14641 3 4.25098 3C7.72066 3 10.2793 3 13.749 3C14.8536 3 15.75 3.89543 15.75 5V11.2857C15.75 12.3903 14.8546 13.2857 13.75 13.2857H5.63059C5.30494 13.2857 4.99477 13.4246 4.77793 13.6676L2.25 16.5V5Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.86015 5.34737C8.90819 5.21754 9.09181 5.21754 9.13985 5.34737L9.86226 7.29964C9.87736 7.34046 9.90954 7.37264 9.95036 7.38774L11.9026 8.11015C12.0325 8.15819 12.0325 8.34181 11.9026 8.38985L9.95036 9.11226C9.90954 9.12736 9.87736 9.15954 9.86226 9.20036L9.13985 11.1526C9.09181 11.2825 8.90819 11.2825 8.86015 11.1526L8.13774 9.20036C8.12264 9.15954 8.09046 9.12736 8.04964 9.11226L6.09737 8.38985C5.96754 8.34181 5.96754 8.15819 6.09737 8.11015L8.04964 7.38774C8.09046 7.37264 8.12264 7.34046 8.13774 7.29964L8.86015 5.34737Z"
        fill={iconColor}
      />
    </StyledSVG>
  );
};
